/**
 * @copyright 2019 @ DigiNet
 * @author rocachien
 * @create 2019/06/02 03:37
 * @update 2019/06/02 03:37
 * @file src/reducers/setting.js
 */

import * as types from '../actions/types.js';

const initialState = {
    numberBadge: null,
    listNotification: null,
};

export default function(state = initialState, action = {}) {
    switch (action.type) {
        case types.GET_NUMBER_BADGE_COMPLETE:
            return{
                ...state,
                numberBadge: action.numberBadge
            };
        case types.LIST_NOTIFICATIONS_COMPLETE:
            return{
                ...state,
                listNotification: action.listNotification
            };

        default:
            return state;
    }
}